import request from "../Config/axios";
// -----------------------------------------------------------
export const GetCurrentRole_User_Api = async () => {
    const { data } = await request.get(
        `/User/GetCurrentRole`
    );
    return data;
};
// -----------------------------------------------------------
export const SendVerifySms_User_Api = async (mobile) => {
    const { data } = await request.post(
        `/User/SendVerifySms/?mobile=${mobile}`
    );
    return data;
};
// -----------------------------------------------------------
export const VerifyMobile_User_Api = async (params) => {
    const { data } = await request.post(
        `/User/VerifyMobile`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const AddUser_User_Api = async (params) => {

    const { data } = await request.postMultiPart(
        `/User/AddUser`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetPerson_User_Api = async (params) => {
    const { data } = await request.post(
        `/User/GetPerson`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetCurrentUserInfo_User_Api = async () => {
    const { data } = await request.get(
        `/User/GetCurrentUserInfo`
    );
    return data;
};
// -----------------------------------------------------------
export const UpdateCurrentUserInfo_User_Api = async (params) => {

    const { data } = await request.postMultiPart(
        `/User/UpdateCurrentUserInfo`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Update_User_Api = async (params) => {

    const { data } = await request.postMultiPart(
        `/User/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Paging_User_Api = async (params) => {

    const { data } = await request.post(
        `/User/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_User_Api = async (id) => {
    const { data } = await request.delete(
        `/User/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_User_Api = async (id) => {
    const { data } = await request.get(
        `/User/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
// API جدید برای سورت و جستجوی پیشرفته
export const GetUsersPagedAdvanced_Api = async (queryParams) => {
    const { data } = await request.post(
        `/User/GetUsersPagedAdvanced`,
        queryParams // ارسال به صورت POST body
    );
    return data;
};
// -----------------------------------------------------------
